export function setNoteForTitle(title: string, hasCommercialComplexes: boolean) {
  if (hasCommercialComplexes) {
    return `${title}*`;
  }

  return title;
}
